<template>
    <nav class="Tabs">
        <Tab :text="SearchTabText.PROGRAMMES" :selected="selectedTabProgrammes" @click="switchTab(SearchType.PROGRAMME_SEARCH)"/>
        <Tab :text="SearchTabText.UNIVERSITIES" :selected="selectedTabUniversities" @click="switchTab(SearchType.UNIVERSITY_SEARCH)" />
        <Tab v-if="shouldDisplayScholarshipsTab" :text="SearchTabText.SCHOLARSHIPS" :selected="selectedTabScholarships" @click="switchTab(SearchType.SCHOLARSHIP_SEARCH)" />
    </nav>
</template>

<script setup lang="ts">
import { SearchTabText } from '@domain/enums/SearchTabText';
import Tab from './Tab/Tab.vue';
import { computed } from 'vue';
import { useSearchStore } from '@app/stores/useSearchStore';
import { PortalType } from '@studyportals/domain-client';
import { SearchType } from '@domain/enums/SearchType.js';

const store =  useSearchStore();

const selectedTabProgrammes = computed(() => store.searchType === SearchType.PROGRAMME_SEARCH);
const selectedTabUniversities = computed(() => store.searchType === SearchType.UNIVERSITY_SEARCH);
const selectedTabScholarships = computed(() => store.searchType === SearchType.SCHOLARSHIP_SEARCH);

const isCurrentTab = (searchType: SearchType): boolean => {
    switch (searchType) {
        case SearchType.PROGRAMME_SEARCH:
            return selectedTabProgrammes.value;
        case SearchType.UNIVERSITY_SEARCH:
            return selectedTabUniversities.value;
        case SearchType.SCHOLARSHIP_SEARCH:
            return selectedTabScholarships.value;
        default:
            return false;
    }
};
const shouldDisplayScholarshipsTab = computed(() => {
    return store.portalType === PortalType.MASTER
        || store.portalType === PortalType.BACHELOR
        || store.portalType === PortalType.PHD;
});

const switchTab = (searchType: SearchType) => {
    if (isCurrentTab(searchType)) return;

    store.setSearchTab(searchType);
};
</script>

<style scoped lang="scss">
.Tabs {
    display: flex;
    @include PaddingAreas(0.5, 0, 0, 0);
    gap: 1rem;
}
</style>
